<template>
  <div
    class="-mx-4 lg:-mx-10 px-4 lg:px-10 border-t border-b border-secondary-50 dark:border-darkblue-600 mt-2 py-2 flex items-center"
  >
    <template v-if="hasTags">
      <div
        class="filters-applied flex flex-row-reverse space-x-reverse space-x-2 overflow-y-auto overflow-x-auto w-full"
      >
        <base-filter-tag-item
          v-for="tag in finalTags"
          :key="tag[0]"
          :tag="tag"
          @removeTag="removeTag"
        />
      </div>
      <div class="flex flex-row ml-2" :class="{ 'w-96': !hideSave, 'w-44': hideSave }">
        <base-button v-if="!hideSave" class="flex-none" @click="saveTags" size="xs" mode="primary-line">
          {{ $t('app.save_search') }}
        </base-button>
        <base-button class="flex-none ml-2" @click="removeAllTags" size="xs" mode="primary-line">
          {{$t('app.filters.remove_filters')}}
        </base-button>
      </div>
    </template>
    <template v-else>
      <div class="flex h-8 items-center mx-auto">
        <base-icon name="filter" size="sm" class="text-secondary-200" />
        <span class="text-sm text-secondary-300">{{ $t('app.non_filters') }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

export default {
  name: 'base-table-filter-tags',
  props: {
    tags: {
      type: [Array],
      required: true
    },
    hideSave: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return { multipleFilters: TIPOS_FILTER_MULTIPLE, }
  },
  computed: {
    hasTags: function () {
      return this.tags.length > 0
    },
    finalTags: function () {
      const finalTags = this.tags
      const multipleTags = finalTags.filter(tag => this.isMultipleTag(tag))
        .map(tag => { tag[2] = tag[2].map((x, i) => [tag[0] + (i + 1), tag[1], x, ...tag.slice(3), i]); return tag })
      multipleTags.forEach(tag => finalTags.splice(finalTags.findIndex(ftag => ftag[0] === tag[0]), 1, ...tag[2]))
      return finalTags
    },
  },
  methods: {
    isMultipleTag: function (tag) {
      return this.multipleFilters.some(x => x.NombreTag === tag[0]) && Array.isArray(tag[2])
    },
    removeTag: function (val) {
      this.$emit('removeTag', val)
    },
    removeAllTags: function () {
      this.$emit('removeAllTags')
    },
    saveTags: function () {
      if (!this.hideSave) {
        this.$emit('saveTags')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
